// src/utils/google-analytics.js
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-ED24P8B9ZD";

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

// GA4 page view
export const trackPageView = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path, 
  });
};

// Custom events
export const trackEvent = (eventName, params = {}) => {
  ReactGA.event(eventName, {
    page_path: window.location.pathname,
    ...params,
  });
};
